import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-24 md:py-32 bg-background-50">
      <div className="w-full px-4 md:px-8 lg:px-16">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full border border-accent-300 bg-accent-50 text-accent-700 text-xs font-medium mb-5">
            Categorie
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
            Esplora le Categorie{' '}
            <span className="text-primary-500 italic">Prodotti</span>
          </h2>
          <p className="text-foreground-500 text-base max-w-xl mx-auto">
            Sfoglia tutte le categorie disponibili su Itaobuy Spreadsheet e trova esattamente ciò che cerchi
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 max-w-7xl mx-auto">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col p-6 rounded-xl bg-background-50 border border-background-200 hover:border-primary-200 hover:bg-primary-50/30 transition-all cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-100 group-hover:bg-primary-100 transition-colors mb-4">
                <i className={`${cat.icon} text-lg text-foreground-700 group-hover:text-primary-600 transition-colors`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed mb-4 flex-1">
                {cat.description}
              </p>
              <span className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-500 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                Scopri di più
                <i className="ri-arrow-right-up-line text-sm group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}